import { Box, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import { getTransportRequestById } from '../../../../../api/transports';
import LoadingAnimation from '../../../../../reusable-components/loader/LoadingAnimation';
import RequestDetailsForm from './RequestDetailsForm';

export default function RequestDetails() {
  const { id, date } = useParams();
  const location = useLocation();
  const occurrenceId = location.state?.occurrenceId || null;
  const initialRequest = location.state?.request || null;
  const [request, setRequest] = useState(initialRequest);
  const [loading, setLoading] = useState(!initialRequest && !!id);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!location.state?.request && id) {
      setLoading(true);
      setError(null);
      getTransportRequestById(id, date, occurrenceId)
        .then((response) => {
          setRequest(response.data);
          setLoading(false);
        })
        .catch(() => {
          setError('Failed to load request details.');
          setLoading(false);
        });
    }
  }, [id, location.state, date]);

  if (loading) {
    return (
      <Box sx={{ justifySelf: 'center' }}>
        <LoadingAnimation />
      </Box>
    );
  }

  if (error) {
    return (
      <Box sx={{ p: 4 }}>
        <Typography variant="h6" color="error">
          {error}
        </Typography>
      </Box>
    );
  }

  if (!loading && !error && !request) {
    return (
      <Box sx={{ p: 4 }}>
        <Typography variant="h6" color="error">
          No data found.
        </Typography>
      </Box>
    );
  }

  return <RequestDetailsForm request={request} setRequest={setRequest} />;
}
